<script setup lang="ts">
import { AppMapLayerSwitcher, AppDrawer } from '@libs/ui';

import type { MapboxStyleType } from './models';

interface MapSettingsDrawerProps {
  mapType: MapboxStyleType;
}

const props = defineProps<MapSettingsDrawerProps>();

interface MapSettingsDrawerEmits {
  (eventName: 'close'): void;
  (eventName: 'change-map-type', mapType: MapboxStyleType): void;
}

const emit = defineEmits<MapSettingsDrawerEmits>();

function handleMapChange(mapType: MapboxStyleType): void {
  if (mapType === props.mapType) {
    return;
  }

  emit('change-map-type', mapType);
}
</script>

<template>
  <AppDrawer :height="{ value: 220, unit: 'px' }" @close="emit('close')">
    <template #header>
      <div class="map-settings-drawer-header">
        {{ $t('planner.map_settings') }}
      </div>
    </template>
    <template #content>
      <div class="map-settings-drawer-content">
        <AppMapLayerSwitcher
          :selected="props.mapType"
          :streets-text="$t('planner.standard_map')"
          :satellite-text="$t('planner.satellite_map')"
          class="map-layer-switcher"
          @streets-selected="handleMapChange('streets')"
          @satellite-selected="handleMapChange('satellite')"
        />
      </div>
    </template>
  </AppDrawer>
</template>

<style scoped lang="scss">
.map-settings-drawer-header {
  @include font-title-label-m;
}

.map-settings-drawer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .map-layer-switcher {
    padding: var(--spacing-24) 0;
  }
}
</style>
